export const gmaBasePath = ['gmi', 'gma'];

export const gmaReferencePath = [...gmaBasePath, 'reference'];
export const gmaContentPath = [...gmaBasePath, 'content'];
export const gmaSubscriptionPath = [...gmaBasePath, 'subscription'];
export const gmaReservationPath = [...gmaBasePath, 'reservation'];
export const gmaVehiclesPath = [...gmaBasePath, 'vehicles'];

export const loyaltyTermsPath = [...gmaContentPath, 'terms', 'loyalty', 'terms_and_conditions'];
